import { useEffect, useState } from "react"
import { useSelector, useDispatch } from 'react-redux';
import { FetchHandler } from "../../Handlers/FetchHandler";
import { LocalStore } from "../../Handlers/LocalStore";
import { RdxStore } from "../../rdx/ReduxTypes";
import { PlantTypeType } from "../../rdx/Redux.DataReducerType";



const ALL_LANGUAGES = [
    // "sv", 
    "no", "en", "en-us"];



const ALL_FIELDS = [
    "name",
    "specifictype",
    "public_description"
];

const getLocalArr = (key: string, defaultValue: string[]) => {
    const str = localStorage.getItem(key);
    if (!!str) {
        return JSON.parse(str)
    } else {
        return defaultValue;
    }
}
const setLocalArr = (key: string, v: string[]) => {
    const str = localStorage.setItem(key, JSON.stringify(v));
}
const LCOAL_KEY_LANGUAGES = "translations_langs";
const LCOAL_KEY_FIELDS = "translations_fields";

export const useTranslationsManager = () => {
    const ss: PlantTypeType[] = useSelector((state: RdxStore) => state.data.planttypes);
    const types: { value: string, label: string }[] = ss.map(o => { return { value: o.id, label: o.name } });

    //const options = [{ value: "-", label: "Inget filter" }].concat(types);

    const api = useTranslationsManagerApi();



    const [loading, setLoading] = useState<boolean>(false);
    const [db, setDB] = useState<Record<string, PlantTranslationType>>({});
    const [dataRaw, setDataRaw] = useState<PlantTranslationType[]>([]);
    const [dataFiltered, setDataFiltered] = useState<PlantTranslationType[]>([]);
    const [selectedLanguages, setSelectedLanguages] = useState<string[]>(getLocalArr(LCOAL_KEY_LANGUAGES, ALL_LANGUAGES));
    const [selectedFields, setSelectedFields] = useState<string[]>(getLocalArr(LCOAL_KEY_FIELDS, ALL_FIELDS));

    const [changes, setChanges] = useState<any>({});

    const sortFunction = (a: PlantTranslationType, b: PlantTranslationType) => {
        const ak = a?.[sort?.field];
        const bk = b?.[sort?.field];
        const d = sort?.direction ?? "asc";

        if (ak > bk) { return d == "asc" ? 1 : -1; }
        else if (ak < bk) { return d == "asc" ? -1 : 1; }
        else { return 0; }

    }
    const [plantTypeId, setPlantTypeId] = useState<string>("ee4384cb-6220-41f7-9c7d-f3a9b2b0e621")

    const load = async () => {
        setLoading(true);
        setChanges({});
        let ret: PlantTranslationType[] = await api.getByPlantTypeId(plantTypeId);

        ret.sort(sortFunction);

        setDataRaw(ret);
        setDataFiltered(ret.filter((n, idx) => idx < 100));

        setLoading(false);


    }


    const missing = (e: string) => {
        setDataFiltered(dataRaw.filter(m => !m?.[e]));
    }
    const resetFilter = () => {
        setDataFiltered(dataRaw.filter((n, idx) => idx < 100));
    }
    const filterName = (e: string) => {
        const f = e?.toLowerCase() ?? "";
        setDataFiltered(dataRaw.filter((n, idx) => {
            return n?.name?.toLowerCase()?.includes(f)
        }));
    }

    const addUpdate = (e: PlantTranslationType, field: string, value: string) => {
        const id = e?.id;
        const _value = value?.trim();
        let _new = { ...changes };
        if ((e?.[field] ?? "") !== (_value ?? "")) {
            _new[id] = { ..._new[id], [field]: _value };
        } else {
            if (_new?.[id]?.hasOwnProperty(field)) {
                delete _new[id][field];
            }
            if (Object.keys(_new?.[id] ?? {}).length == 0 && !!_new[id]) {
                delete _new[id];
            }
        }
        setChanges(_new);
    }
    const saveChanges = async () => {
        const url = "/api/translationplants/save";
        const success: boolean = await FetchHandler.patchJson(url, changes);
        if (success === true) {
            setChanges({})
        }
    }

    // *********************** Sort ***********************
    const [sort, setSort] = useState<ObjectSortType>({ field: "name", direction: "asc" });


    const reSort = async () => {
        setLoading(true);
        let ret: PlantTranslationType[] = dataRaw;
        ret.sort(sortFunction);
        setDataRaw(ret);
        setDataFiltered(ret.filter((n, idx) => idx < 100));
        setLoading(false);
    }
    useEffect(() => {
        reSort();
    }, [sort])

    // *********************** plantTypeId ***********************

    return {
        loading,
        dataRaw,
        dataFiltered,
        load,

        missing,
        resetFilter,
        filterName,
        addUpdate,
        changes,
        saveChanges,
        sort, setSort: (e: string) => {
            if (sort.field === e) {
                setSort({ ...sort, direction: sort?.direction === "asc" ? "desc" : "asc" });
            } else {
                setSort({ field: e, direction: "asc" })
            }
        },
        plantTypes: types,
        plantTypeId, setPlantTypeId,
        ALL_LANGUAGES,
        selectedLanguages,
        setLanguages: (e: string) => {

            if (selectedLanguages.indexOf(e) >= 0) {
                const t = selectedLanguages.filter(m => m !== e);
                setSelectedLanguages(t);
                setLocalArr(LCOAL_KEY_LANGUAGES, t);
            } else {
                const t = [...selectedLanguages, e];
                setSelectedLanguages(t);
                setLocalArr(LCOAL_KEY_LANGUAGES, t);
            }
        },
        ALL_FIELDS,
        selectedFields: selectedFields,
        setSelectedFields: (e: string) => {
            if (selectedFields.indexOf(e) >= 0) {
                const t = selectedFields.filter(m => m !== e);
                setSelectedFields(t);
                setLocalArr(LCOAL_KEY_FIELDS, t);
            } else {
                const t = [...selectedFields, e];
                setSelectedFields(t);
                setLocalArr(LCOAL_KEY_FIELDS, t);
            }

        },
        translateText: async (text: string, plantName: string, language: string) => {
            return api.translateText(text, plantName, language);
        }

    }
}

export const useTranslationsManagerApi = () => {

    return {
        getByPlantTypeId: async (plantTypeId: string): Promise<PlantTranslationType[]> => {
            const ret: PlantTranslationType[] = await FetchHandler.getJson("/api/translationplants?type=" + plantTypeId);
            return ret;
        },
        translateText: async (text: string, plantName: string, language: string) => {
            const url = "/api/translationplants/translate";
            const postObj = { text, plantName, language };
            const { translatedText, success } = await FetchHandler.postJson(url, postObj);
            if (success) {
                return translatedText;
            } else {
                return "";
            }
            // return text + " på språk '" + language + "'";
        },
    }
}

export type PlantTranslationType = {
    id: string
    name: string
    name_no: string
    name_en: string
    "name_en-us": string

    specifictype: string
    specifictype_no: string
    specifictype_en: string
    "specifictype_en-us": string

    namegroup_no: string
    namegroup_en: string
    "namegroup_en-us": string

    public_description: string
    public_description_no: string
    public_description_en: string
    "public_description_en-us": string

    alternativenames: string
    alternativenames_no: string
    alternativenames_en: string
    "alternativenames_en-us": string

    namelatin: string
    familyname: string

}
export type ObjectSortType = {
    field?: string,
    direction?: "asc" | "desc"
};
